// Runtime access to three.js.
//
// We vendor the classic UMD build (public/vendor/three.min.js) which attaches
// `THREE` to window as a global — the same approach the backdoors game uses and
// which is proven to work in this environment. We pull the runtime object from
// the global here and re-type it with the real @types/three definitions, so the
// rest of the client gets full type-checking while the bundle stays tiny (three
// itself is never bundled — only `import type` references, which esbuild erases).

import type * as ThreeNS from "three";

const THREE = (globalThis as unknown as { THREE: typeof ThreeNS }).THREE;

if (!THREE) {
  // Loud, early failure beats a cryptic "THREE is undefined" deep in the scene.
  throw new Error(
    "three.js global not found — public/vendor/three.min.js must load before game.js",
  );
}

export default THREE;
